// removed by extract-text-webpack-plugin
module.exports = {"footerContainer":"_35rMLGVUWnRJz6kp9mEtst","copyright":"GjM_a45sAJdlJ5yjQdXMA","contactUs":"_38XjjfJ6ZxU0jN9RIVqZ6m","social":"_3KL_V3-rO9r8rWAaTfa5Mo","contactInfo":"_3q99jSOtLVE5PA6Kpx7VSB","socialLink":"UAIPGUHbsIfuu3ZA2Rwz_","linkTo":"_28ej8qDBM9-SShEDhEvVLl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/Footer.css
// module id = 350
// module chunks = 0